import { useCookies } from 'react-cookie';
import { useEffect } from 'react';
import useQueryParams from '../navigation-utils/useQueryParams';
import {
  AUTH_INVITATION_QUERY_PARAM_NAME,
  AUTH_ORG_COOKIE_NAME,
  AUTH_ORG_QUERY_PARAM_NAME,
} from './authConsts';
import { useAccountSelectionContext } from '../components/account-selection/AccountSelectionContext';

export const useAuthOrg = () => {
  const [cookies, setCookie] = useCookies();
  const queryParams = useQueryParams();
  const { isAuthZeroAccessDenied, isSSOUser } = useAccountSelectionContext();

  const authOrgIdQueryParam = queryParams.get(AUTH_ORG_QUERY_PARAM_NAME);
  const invitationQueryParam = queryParams.get(AUTH_INVITATION_QUERY_PARAM_NAME);

  useEffect(() => {
    const allowSettingCookie = isSSOUser ? true : !isAuthZeroAccessDenied;
    //relevant for orgs with SSO configured in Auth0 (not relevant for "invitation" flow)
    //if auth0 access denied, don't set the cookie so we can redirect to the correct account on the next attempt
    if (authOrgIdQueryParam && !invitationQueryParam && allowSettingCookie) {
      setCookie(AUTH_ORG_COOKIE_NAME, authOrgIdQueryParam, { path: '/' });
    }
  }, [authOrgIdQueryParam, invitationQueryParam, setCookie, isAuthZeroAccessDenied, isSSOUser]);

  const authOrgId = authOrgIdQueryParam ?? cookies[AUTH_ORG_COOKIE_NAME];
  const authOrgQueryParam = authOrgId ? `${AUTH_ORG_QUERY_PARAM_NAME}=${authOrgId}` : '';

  return { authOrgId, authOrgQueryParam };
};
